<p-dialog [(visible)]="display"
    class="comment-dialog"
    [modal]=true [closable]=true
    (onShow)="commentTextInput.focus()"
    (onHide)="close()"
    [style.height]="300"
    [closeOnEscape]=false 
    header="Comments for Request {{authority === null ? '' : authority.ec1Number}}">
    <div class="right-align">
        <textarea #commentTextInput pInputTextarea
            class="comment-input"
            rows="5" maxlength="250" 
            [ngModel]="comment"
            (ngModelChange)="updateLength($event)">
        </textarea>
        <label>{{commentLength}}/250</label>
    </div>
    <p-footer>
        <button type="button" pButton label="Cancel" (click)="onCancel()" class="p-button-outlined w-16rem"></button>
        <button type="button" class="md:ml-1 w-16rem" pButton label="Submit" (click)="onSubmit()" [disabled]="!validForSubmit"></button>
    </p-footer>
</p-dialog>